export enum URLS {
  SEARCH_CONTEXT_LANDING_PAGE = '/shop',
  CONFIGURED_LANDING_PAGE = '/g',
  CART_PAGE = '/cart',
  PDP_PAGE = '/i',
}
